import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const SponsorRow = ({ logos, duration, reverse }) => {
  const doubled = [...logos, ...logos];
  return (
    <div className={`sponsor-track${reverse ? ' sponsor-track--reverse' : ''}`} style={{ '--marquee-duration': duration }}>
      {doubled.map((logo, i) => (
        <a key={i} href={logo.url} target="_blank" rel="noopener noreferrer" className="sponsor-item">
          <img src={logo.src} alt={logo.name} />
        </a>
      ))}
    </div>
  );
};

const Footer = ({ onOpenModal }) => {
  const { t } = useTranslation();
  const [partnerLogos, setPartnerLogos] = useState([]);

  useEffect(() => {
    const imageNames = [
      { name: 'CC-logo-gray.svg', url: 'https://www.claimscon.org' },
      { name: 'ustecky_kraj.png', url: 'https://www.kr-ustecky.cz/' },
      { name: 'Dubi_CoA_CZ.jpg', url: 'https://www.mesto-dubi.cz/' },
      { name: 'esjf.svg', url: 'https://www.esjf-cemeteries.org/' },
      { name: 'teplice.png', url: 'https://www.teplice.cz/' },
      { name: 'Kadan.png', url: 'https://www.mesto-kadan.cz/' },
      { name: 'krupka.png', url: 'https://www.krupka-mesto.cz/' },
      { name: 'logo-fond-budoucnosti.svg', url: 'https://www.fondbudoucnosti.cz/' },
      { name: 'most_logotyp_cb_cerny.png', url: 'https://www.mesto-most.cz/' },
      { name: 'foundation_for_holocaust_victims.jpg', url: 'https://fondholocaust.cz/' },
      { name: 'spencer.webp', url: 'https://www.spencer.it/en' },
      { name: 'technicke sluzby mesta mostu.jpeg', url: 'https://tsmost.cz/' },
      { name: 'ZO Praha.jpg', url: 'https://www.kehilaprag.cz/' },
    ];

    const imageExtensions = /\.(png|jpe?g|svg|webp|avif|gif)$/i;
    const logos = imageNames
      .filter(e => imageExtensions.test(e.name))
      .map(e => ({
        src: `/footer/support/${e.name}`,
        name: e.name.replace(imageExtensions, ''),
        url: e.url,
      }));

    setPartnerLogos(logos);
  }, []);

  const mid = Math.ceil(partnerLogos.length / 2);
  const row1 = partnerLogos.slice(0, mid);
  const row2 = partnerLogos.slice(mid);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-info">
            <div className="footer-contact">
              <h3 className="footer-heading">{t('footer.contactUs')}</h3>
              <address className="footer-address">
                <p>{t('footer.address')}</p>
                <p>{t('footer.city')}</p>
                <p>{t('footer.country')}</p>
              </address>
              <div className="footer-contact-info">
                <a href="mailto:info@kehila-teplice.cz" className="footer-link">
                  info@kehila-teplice.cz
                </a>
                <a href="tel:+420417635073" className="footer-link">
                  +420 417 635 073
                </a>
              </div>
            </div>

            <div className="footer-links">
              <button className="footer-modal-btn" onClick={() => onOpenModal('contact')}>
                {t('footer.contactUs')}
              </button>
              <button className="footer-modal-btn" onClick={() => onOpenModal('bank')}>
                {t('footer.bankDetails')}
              </button>
              <button className="footer-modal-btn" onClick={() => onOpenModal('faq')}>
                {t('footer.faq')}
              </button>
              <a href="https://www.fzo.cz/projekty-fzo/forum-proti-antisemitismu/formular-nahlaseni/">
                <div className="footer-report-antisemitism">
                  <img src="/Report.png" alt="Report antisemitism" />
                </div>
              </a>
            </div>
          </div>

          {partnerLogos.length > 0 && (
            <div className="footer-partners-wrapper">
              <SponsorRow logos={row1} duration="55s" reverse={false} />
              <SponsorRow logos={row2} duration="45s" reverse={true} />
            </div>
          )}
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Židovská obec Teplice. {t('footer.allRightsReserved')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
